const {
  onlyNumericNormalize,
  zipCodeRegexNumeric,
  SPACE
} = require('../helpers');

const states = {
  'Región de Tarapacá': 'Región de Tarapacá',
  'Región de Antofagasta': 'Región de Antofagasta',
  'Región de Atacama': 'Región de Atacama',
  'Región de Coquimbo': 'Región de Coquimbo',
  'Región de Valparaiso': 'Región de Valparaíso',
  "Región de O'Higgins": "Región del Libertador General Bernardo O'Higgins",
  'Región del Maule': 'Región del Maule',
  'Región del Bio Bío': 'Región del Bío Bío',
  'Región de la Araucanía': 'Región de La Araucanía',
  'Región de los Lagos': 'Región de Los Lagos',
  'Aysén Región': 'Región de Aysén del General Carlos Ibáñez del Campo',
  'Región de Magallanes': 'Región de Magallanes',
  'Región Metropolitana': 'Región Metropolitana',
  'Región de los Ríos': 'Región de Los Ríos',
  'Región Arica and Parinacota': 'Región de Arica y Parinacota'
};

const stateOptions = [];
for (const key of Object.keys(states)) {
  stateOptions.push({ value: key, name: states[key] });
}
exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 7);

exports.countryDefinition = {
  country: 'Chile',
  code: 'CL',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town' },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'State',
      width: 0.5
    },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city', SPACE, 'stateCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['zipCode', 'stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(7)),
      error: 'Must be 7 numbers, 8720019'
    }
  ]
};
